@if(viewVerificationCode == false){
<ng-container>
  <div id="main-wrapper" class="min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row h-100 w-100">
      <!-- <div class="col-lg-6 d-lg-flex align-items-center justify-content-center login-set-bg pe-0">
          <div class="login-content">
            <h2>Specialists in R&D Tax and other innovation incentives</h2>
            <p>
              The UK Government has committed to raising investment in Research and
              Development (R&D) to 2.4% of Gross Domestic Product (GDP) by 2027. To
              further this objective, generous tax relief and grant funding schemes
              are available for companies undertaking research and development.
            </p>
            <p>
              iTax Advisors Limited is a specialist innovation tax consultancy
              focused solely on assisting UK companies in harnessing these
              government incentives.
            </p>
            <div class="video-btn">
              <button class="btn btn-primary">
                <span>Video</span>
                <img src="../../../assets/Krid/img/video-icon.svg" alt="" />
              </button>
            </div>
          </div>
        </div> -->
      <div class="col-lg-12 px-0">
        <div class="pattern-design d-flex align-items-center justify-content-center">
          <div class="row d-flex flex-column justify-content-center">
            <div class="col-lg-12 col-12 m-auto d-flex justify-content-center">
              <div class="p-3">
                <div class="mb-4 mt-3 mt-lg-0">
                  <img src="../../../assets/Krid/img/main-logo.svg" class="m-auto d-table logo" alt />
                </div>
                <div class="heading">
                  <h2>Sign in</h2>
                  <p>Enter your email and password to access your account</p>
                </div>
                <form [formGroup]="loginForm" (ngSubmit)="submitLoginForm()" novalidate>
                  <div class="form-group mb-4">
                    <label for="exampleInputEmail1">{{ labelConstants.Email
                      }}<span class="text-danger">*</span></label>
                    <input placeholder="Enter Email" oninput="this.value = this.value.replace(/^\s+/g, '')"
                      oninput="this.value = this.value.toLowerCase()" type="email" formControlName="UserEmail"
                      class="form-control mb-1" id="exampleInputEmail1" maxlength="100" />
                    <span class="text-danger"
                      *ngIf="submitted && loginFormControls['UserEmail'].errors?.['required']">{{
                      errorConstants.EmalRequired }}</span>
                    <span class="text-danger" *ngIf="submitted && loginFormControls['UserEmail'].errors?.['pattern']">{{
                      errorConstants.EmailNotValid }}</span>
                  </div>
                  <div class="form-group mb-3">
                    <label for="exampleInputPassword1">{{ labelConstants.Password
                      }}<span class="text-danger">*</span></label>
                    <div class="position-relative mb-1">
                      <input placeholder="Enter Password" oninput="this.value = this.value.replace(/^\s+/g, '')"
                        [type]="isShowPassword ? 'text' : 'password'" formControlName="UserPassword"
                        class="form-control" id="exampleInputPassword1" maxlength="100" />
                      <mat-icon matSuffix class="icon-set" (click)="togglePasswordVisibility()">{{
                        isShowPassword ? "visibility_off" : "visibility"
                        }}</mat-icon>
                    </div>
                    <span class="text-danger mt-1"
                      *ngIf="submitted && loginFormControls['UserPassword'].errors?.['required']">{{
                      errorConstants.PasswordRequired }}</span>
                  </div>
                  <div class="mb-3 w-100" *ngIf="IsShowCapcha">
                    <re-captcha formControlName="recaptcha" name="captcha">
                    </re-captcha>
                    <div class="field-error" *ngIf="submitted && loginForm.recaptcha.errors">
                      Recaptcha is required.
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <div class="toggle">
                      <input type="checkbox" id="temp" formControlName="rememberMe" />
                      <label for="temp">Remember me</label>
                    </div>
                    <a href="javascript:void(0)" class="forgot-link float-right text-danger"
                      (click)="onForgotPassword()">{{ labelConstants.ForgotPass }}</a>
                  </div>
                  <button type="submit" [disabled]="!loginForm.valid || isLoading" class="btn login-btn mt-3 mb-3"
                    [ngClass]="{ loading: isLoading }">
                    <span *ngIf="!isLoading">{{ labelConstants.Login }}</span>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                  </button>
                </form>
                <div class="rights-content"><span>
                    <a href="javascript:void(0)" (click)="openDialog('privacy')"> Privacy Policy </a> &nbsp; | &nbsp;
                    <a
                      href="javascript:void(0)"(click)="openDialog('legal')">Legal</a></span></div>
                <div class="rights-content">
                  <label>© {{currentYear}} ALL RIGHTS RESERVED &#124;</label>&nbsp;
                  <span>KRID</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
}
@else {
<ng-container>
  <app-verification-code [verificationResponse]="verificationResponse"
    (viewVerificationCode)="goLogin()"></app-verification-code>
</ng-container>
}
